import { motion } from "framer-motion";
import { ArrowRight, ChevronDown } from "lucide-react";

export const HeroSection = () => {
  const scrollTo = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="hero" data-testid="hero-section" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 bg-brand-navy" />
      <div className="absolute inset-0 opacity-20" style={{ backgroundImage: `radial-gradient(circle at 20% 50%, #2bb5b2 0%, transparent 50%), radial-gradient(circle at 80% 20%, #2bb5b2 0%, transparent 40%)` }} />
      <div className="absolute inset-0 opacity-[0.04]" style={{ backgroundImage: `linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)`, backgroundSize: "60px 60px" }} />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 md:py-40">
        <div className="max-w-3xl">
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.2 }}>
            <span className="inline-block text-brand-teal text-sm font-bold uppercase tracking-[0.2em] mb-6">Consultoria Especializada</span>
          </motion.div>

          <motion.h1 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.4 }}
            className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight tracking-tight mb-8" data-testid="hero-title">
            Soluções Estratégicas em{" "}<span className="text-brand-teal">Benefícios</span> e{" "}<span className="text-brand-teal">Seguros</span>
          </motion.h1>

          <motion.p initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.6 }}
            className="text-lg text-slate-300 leading-relaxed mb-12 max-w-2xl" data-testid="hero-subtitle">
            Mais de 30 anos de experiência otimizando resultados e transformando a performance de operadoras e corretoras no mercado brasileiro.
          </motion.p>

          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.8 }} className="flex flex-col sm:flex-row gap-4">
            <button onClick={() => scrollTo("#contato")} data-testid="hero-cta-primary"
              className="group bg-brand-teal text-white px-8 py-4 rounded-md font-semibold text-base hover:bg-teal-600 transition-all duration-300 hover:scale-105 hover:shadow-xl flex items-center justify-center gap-3">
              Transforme Seus Resultados
              <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
            </button>
            <button onClick={() => scrollTo("#servicos")} data-testid="hero-cta-secondary"
              className="border-2 border-white/20 text-white px-8 py-4 rounded-md font-semibold text-base hover:border-brand-teal hover:text-brand-teal transition-all duration-300">
              Conheça Nossos Serviços
            </button>
          </motion.div>
        </div>
      </div>

      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.5 }} className="absolute bottom-8 left-1/2 -translate-x-1/2">
        <motion.div animate={{ y: [0, 10, 0] }} transition={{ repeat: Infinity, duration: 2 }}>
          <ChevronDown className="text-white/50" size={32} />
        </motion.div>
      </motion.div>
    </section>
  );
};
